import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { FormControl, FormHelperText } from "@mui/material";

const MobileTimePickerComponent = ({
  label = "Select Time",
  value,
  name,
  helperText,
  error,
  fullWidth,
  disabled,
  onChange,
  minTime,
  maxTime,
  id
}) => {
  return (
    <FormControl fullWidth error={error}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileTimePicker
          label={label}
          value={value}
          onChange={onChange}
          minTime={minTime}
          maxTime={maxTime}
          ampm
          size="small"
          disabled={disabled}
          slotProps={{ textField: { size: 'small' } }}
          renderInput={(params) => {
            return <TextField
              size="small"
              id={id}
              name={name}
              {...params}
              fullWidth={fullWidth}
              disabled={disabled}
              error={error}
              helperText={helperText}
            />;
          }}
        />
        {error ? (
          <FormHelperText>{helperText}</FormHelperText>
        ) : null}
      </LocalizationProvider>
    </FormControl>
  );
};

export default MobileTimePickerComponent;
